import moment from 'moment/moment';
import { ISO_DATE_FORMAT } from 'src/shared/constants';

export const DateItems = [
  {
    label: 'Today',
    disabled: false,
    groupBy: 'hour',
    dateRange: 'hours',
    timeAxis: 'minutes',
    showInProgressTickets: true,
    getStartTime: (format = ISO_DATE_FORMAT) => moment().startOf('day').format(format),
    getEndTime: (format = ISO_DATE_FORMAT) => moment().endOf('day').format(format),
    getStartAgentTime: (format = ISO_DATE_FORMAT) => moment().startOf('day').format(format),
    getEndAgentTime: (format = ISO_DATE_FORMAT) => moment().endOf('day').format(format),
  },
  {
    label: 'Yesterday',
    disabled: false,
    groupBy: 'hour',
    default: true,
    dateRange: 'hours',
    timeAxis: 'minutes',
    showInProgressTickets: false,
    getStartTime: (format = ISO_DATE_FORMAT) =>
      moment().subtract(1, 'days').startOf('day').format(format),
    getEndTime: (format = ISO_DATE_FORMAT) =>
      moment().subtract(1, 'days').endOf('day').format(format),
    getStartAgentTime: (format = ISO_DATE_FORMAT) =>
      moment().subtract(1, 'days').startOf('day').format(format),
    getEndAgentTime: (format = ISO_DATE_FORMAT) =>
      moment().subtract(1, 'days').endOf('day').format(format),
  },
  {
    label: 'This week',
    disabled: false,
    groupBy: 'day',
    dateRange: 'day',
    timeAxis: 'minutes',
    showInProgressTickets: true,
    getStartTime: (format = ISO_DATE_FORMAT) => moment().weekday(1).startOf('day').format(format),
    getEndTime: (format = ISO_DATE_FORMAT) => moment().endOf('isoWeek').format(format),
    getStartAgentTime: (format = ISO_DATE_FORMAT) =>
      moment().weekday(1).startOf('day').format(format),
    getEndAgentTime: (format = ISO_DATE_FORMAT) => moment().format(format),
  },
  {
    label: 'Last week',
    disabled: false,
    groupBy: 'day',
    dateRange: 'day',
    timeAxis: 'minutes',
    showInProgressTickets: false,
    getStartTime: (format = ISO_DATE_FORMAT) =>
      moment().subtract(1, 'weeks').startOf('isoWeek').format(format),
    getEndTime: (format = ISO_DATE_FORMAT) =>
      moment().subtract(1, 'weeks').endOf('isoWeek').format(format),
    getStartAgentTime: (format = ISO_DATE_FORMAT) =>
      moment().subtract(1, 'weeks').startOf('isoWeek').format(format),
    getEndAgentTime: (format = ISO_DATE_FORMAT) =>
      moment().subtract(1, 'weeks').endOf('isoWeek').format(format),
  },
  {
    label: 'This month',
    disabled: false,
    groupBy: 'day',
    dateRange: 'day',
    timeAxis: 'minutes',
    showInProgressTickets: true,
    getStartTime: (format = ISO_DATE_FORMAT) =>
      moment().startOf('month').startOf('day').format(format),
    getEndTime: (format = ISO_DATE_FORMAT) => moment().endOf('month').format(format),
    getStartAgentTime: (format = ISO_DATE_FORMAT) =>
      moment().startOf('month').startOf('day').format(format),
    getEndAgentTime: (format = ISO_DATE_FORMAT) => moment().format(format),
  },
  {
    label: 'Last month',
    disabled: false,
    groupBy: 'day',
    dateRange: 'day',
    timeAxis: 'minutes',
    showInProgressTickets: false,
    getStartTime: (format = ISO_DATE_FORMAT) =>
      moment().subtract(1, 'months').startOf('month').format(format),
    getEndTime: (format = ISO_DATE_FORMAT) =>
      moment().subtract(1, 'months').endOf('month').format(format),
    getStartAgentTime: (format = ISO_DATE_FORMAT) =>
      moment().subtract(1, 'months').startOf('month').format(format),
    getEndAgentTime: (format = ISO_DATE_FORMAT) =>
      moment().subtract(1, 'months').endOf('month').format(format),
  },
  {
    label: 'This year',
    disabled: false,
    groupBy: 'day',
    dateRange: 'week',
    timeAxis: 'minutes',
    showInProgressTickets: true,
    getStartTime: (format = ISO_DATE_FORMAT) => moment().startOf('year').format(format),
    getEndTime: (format = ISO_DATE_FORMAT) => moment().endOf('year').format(format),
    getStartAgentTime: (format = ISO_DATE_FORMAT) => moment().startOf('year').format(format),
    getEndAgentTime: (format = ISO_DATE_FORMAT) => moment().format(format),
  },
  {
    label: 'Last year',
    disabled: false,
    groupBy: 'day',
    dateRange: 'month',
    timeAxis: 'minutes',
    showInProgressTickets: false,
    getStartTime: (format = ISO_DATE_FORMAT) =>
      moment().subtract(1, 'year').startOf('year').format(format),
    getEndTime: (format = ISO_DATE_FORMAT) =>
      moment().subtract(1, 'year').endOf('year').format(format),
    getStartAgentTime: (format = ISO_DATE_FORMAT) =>
      moment().subtract(1, 'year').startOf('year').format(format),
    getEndAgentTime: (format = ISO_DATE_FORMAT) =>
      moment().subtract(1, 'year').endOf('year').format(format),
  },
  {
    label: 'Custom',
    disabled: false,
    groupBy: 'day',
    dateRange: 'day',
    timeAxis: 'minutes',
    showInProgressTickets: false,
  },
];

export const DateItemsGroupByX = [
  {
    label: 'Hour',
    groupBy: 'hour',
  },
  {
    label: 'Day',
    groupBy: 'day',
  },
];
export const DateItemsGroupByY = [
  {
    label: 'Seconds',
    groupBy: 'sec',
  },
  {
    label: 'Minutes',
    groupBy: 'min',
  },
  {
    label: 'Hour',
    groupBy: 'hour',
  },
];
